import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import {
  LayoutDashboard,
  Briefcase,
  FilePlus2,
  Search,
  Store,
  Sparkles,
  LogOut,
  BarChart3,
  FolderLock,
  ScrollText,
} from "lucide-react";
import { useAuth } from "../context/AuthContext";

const LOGO = "https://customer-assets.emergentagent.com/job_f59c783b-4061-4c90-8631-f537af31e122/artifacts/nm25t9qa_Calcutta%20Logo.png";

const NAV = [
  { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, testid: "nav-dashboard" },
  { to: "/portfolio", label: "IP Vault", icon: Briefcase, testid: "nav-portfolio" },
  { to: "/register-ip", label: "Add Creation", icon: FilePlus2, testid: "nav-register" },
  { to: "/search", label: "Search", icon: Search, testid: "nav-search" },
  { to: "/analytics", label: "Analytics", icon: BarChart3, testid: "nav-analytics" },
  { to: "/marketplace", label: "Licensing", icon: Store, testid: "nav-marketplace" },
  { to: "/contracts", label: "Licence Builder", icon: ScrollText, testid: "nav-contracts" },
  { to: "/vault", label: "Document Vault", icon: FolderLock, testid: "nav-vault" },
  { to: "/copilot", label: "Assistant", icon: Sparkles, testid: "nav-copilot" },
];

export default function Sidebar() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <aside
      className="w-64 shrink-0 border-r border-slate-200 bg-white flex flex-col h-screen sticky top-0"
      data-testid="app-sidebar"
    >
      <div className="px-6 py-5 border-b border-slate-200 flex items-center gap-3">
        <img src={LOGO} alt="Calcutta" className="w-10 h-10 rounded-sm" />
        <div>
          <div className="font-serif text-xl font-semibold tracking-tight text-slate-900 leading-none">
            Calcutta
          </div>
          <div className="eyebrow mt-1 text-[10px]">by Mahakali Tribunal</div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {NAV.map((item) => {
          const Icon = item.icon;
          return (
            <NavLink
              key={item.to}
              to={item.to}
              data-testid={item.testid}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-sm text-sm font-medium transition-colors ${
                  isActive
                    ? "bg-[#FAD4D4] text-[#7A1F2B]"
                    : "text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                }`
              }
            >
              <Icon size={18} strokeWidth={1.75} />
              <span>{item.label}</span>
            </NavLink>
          );
        })}
      </nav>

      <div className="border-t border-slate-200 p-4">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-9 h-9 rounded-sm bg-[#B33A3A] text-white flex items-center justify-center font-semibold">
            {(user?.name || "U").charAt(0).toUpperCase()}
          </div>
          <div className="min-w-0">
            <div className="text-sm font-medium text-slate-900 truncate">{user?.name || "User"}</div>
            <div className="text-xs text-slate-500 truncate">{user?.email}</div>
          </div>
        </div>
        <button
          onClick={doLogout}
          data-testid="logout-btn"
          className="w-full flex items-center justify-center gap-2 text-sm text-slate-600 hover:text-[#B33A3A] transition-colors py-2 border border-slate-200 rounded-sm hover:border-[#B33A3A]"
        >
          <LogOut size={16} /> Sign out
        </button>
      </div>
    </aside>
  );
}
